// Presentational detail content for service & project detail pages.

export const slugify = (s = "") =>
  s.toLowerCase().replace(/'/g, "").replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

const B = (a, b) => [a, b];

export const SERVICE_DETAILS = {
  roofing: {
    longDesc: [
      "Protect your home from the top down. We inspect, repair and replace roofs of all types, sealing out the weather for good.",
      "From a small leak to a full re-roof, our team works safely and cleanly with durable, warrantied materials.",
    ],
    benefits: ["Roof inspection", "Leak repair", "Full roof replacement", "Gutter installation", "Flashing & sealing", "Storm damage repair"],
  },
  plastering: {
    longDesc: [
      "Flawless walls and ceilings start with expert plastering. We deliver smooth, crack-free finishes ready for decorating.",
      "Skimming, rendering and full re-plasters — all completed cleanly with meticulous attention to detail.",
    ],
    benefits: ["Skimming & re-skims", "Rendering", "Ceiling repairs", "Coving & finishing", "Damp-resistant work", "Clean, tidy finish"],
  },
  extensions: {
    longDesc: [
      "Add space and value with a beautifully built extension. We manage the whole process, from plans to finishing.",
      "Single or double-storey, kitchen or living space — built to last and designed to match your home.",
    ],
    benefits: ["Single & double-storey", "Design & planning", "Foundations & structure", "Building regs handled", "Roofing & finishing", "Project management"],
  },
  "home-renovations": {
    longDesc: [
      "Transform how you live. Our renovation team coordinates every trade for a seamless, stress-free result.",
      "Whole-home or single-room, we deliver stunning transformations on time and on budget.",
    ],
    benefits: ["Full-home renovations", "Design & planning", "All trades coordinated", "Premium finishes", "Dedicated project manager", "On-time completion"],
  },
  kitchens: {
    longDesc: [
      "Your dream kitchen, expertly designed and fitted. We handle supply, plumbing, electrics and finishing.",
      "From sleek modern to warm classic, we build kitchens that look stunning and work beautifully.",
    ],
    benefits: ["Bespoke kitchen design", "Supply & fitting", "Worktops & splashbacks", "Plumbing & electrics", "Tiling & flooring", "Appliance installation"],
  },
  "bathroom-remodelling": {
    longDesc: [
      "Beautiful, functional bathrooms built to last. We manage tiling, plumbing and finishing for a spa-like result.",
      "From compact cloakrooms to luxury en-suites, we deliver a flawless finish every time.",
    ],
    benefits: ["Full bathroom design", "Walk-in showers & baths", "Tiling & waterproofing", "Plumbing & fixtures", "Underfloor heating", "Premium finishes"],
  },
  "general-building-works": {
    longDesc: [
      "No job too big or small. Our general building team handles repairs, alterations and structural works with care.",
      "Reliable, insured and tidy — the safe pair of hands for any project around your home.",
    ],
    benefits: ["Structural works", "Brickwork & repairs", "Alterations", "Groundworks", "Maintenance", "Insured & warrantied"],
  },
};

export const getServiceDetail = (slug) =>
  SERVICE_DETAILS[slug] || {
    longDesc: [
      "Our expert tradespeople deliver quality workmanship on every job, big or small, with transparent pricing and a satisfaction guarantee.",
      "Get in touch for a free, no-obligation quote and see the EMB difference.",
    ],
    benefits: ["Licensed & insured", "Premium materials", "On-time completion", "Clean, tidy work", "Fair, upfront pricing", "Warranty backed"],
  };

const IMG_KITCHEN = B(
  "https://images.unsplash.com/photo-1782292932626-d65ddc106f9e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  "https://images.unsplash.com/photo-1659949294512-95abb6aebf6c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000"
);
const IMG_BATH = B(
  "https://images.pexels.com/photos/31525748/pexels-photo-31525748.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1000",
  "https://images.unsplash.com/photo-1661107259637-4e1c55462428?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000"
);
const IMG_EXT = B(
  "https://images.pexels.com/photos/18214902/pexels-photo-18214902.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1000",
  "https://images.unsplash.com/photo-1721815693498-cc28507c0ba2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000"
);
const IMG_RENO = B(
  "https://images.unsplash.com/photo-1517581177682-a085bb7ffb15?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  "https://images.unsplash.com/photo-1618832515490-e181c4794a45?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000"
);

export const SERVICE_GALLERIES = {
  roofing: [
    "https://images.unsplash.com/photo-1633759593085-1eaeb724fc88?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    "https://images.unsplash.com/photo-1635424824849-1b09bdcc55b1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
  ],
  plastering: [
    "https://images.unsplash.com/photo-1652829069834-2c05031199c5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000",
    "https://images.pexels.com/photos/5583126/pexels-photo-5583126.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1000",
  ],
  extensions: IMG_EXT,
  "home-renovations": IMG_RENO,
  kitchens: IMG_KITCHEN,
  "bathroom-remodelling": IMG_BATH,
  "general-building-works": [
    "https://images.pexels.com/photos/8820170/pexels-photo-8820170.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1000",
    "https://images.pexels.com/photos/7492582/pexels-photo-7492582.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1000",
  ],
};

export const getServiceGallery = (slug) => SERVICE_GALLERIES[slug] || [];

// Extra case-study data for projects, keyed by id.
export const PROJECT_DETAILS = {
  1: { description: "A dated, closed-off kitchen was opened up into a bright, open-plan cooking and dining space with stone worktops, integrated appliances and warm accent lighting.", specs: { Service: "Full Renovation", Duration: "6 weeks", Area: "28 m\u00b2", Location: "Croydon", Completed: "2025" } },
  2: { description: "A moody, characterful chef's kitchen featuring bespoke cabinetry, a statement island and premium fixtures \u2014 built for cooking and entertaining alike.", specs: { Service: "Kitchen Fit", Duration: "5 weeks", Area: "24 m\u00b2", Location: "Croydon", Completed: "2025" } },
  3: { description: "A luxurious marble bathroom suite with a walk-in shower, floating vanity and brushed hardware, delivering a spa-like retreat at home.", specs: { Service: "Bathroom Remodelling", Duration: "4 weeks", Area: "12 m\u00b2", Location: "Croydon", Completed: "2024" } },
  4: { description: "A warm spa bathroom blending natural stone and timber tones, with underfloor heating and soft ambient lighting for year-round comfort.", specs: { Service: "Bathroom Remodelling", Duration: "3 weeks", Area: "10 m\u00b2", Location: "Croydon", Completed: "2024" } },
  5: { description: "A tired facade reimagined into a striking modern exterior, with new cladding, windows and warm architectural lighting that shines at dusk.", specs: { Service: "Extension", Duration: "8 weeks", Area: "160 m\u00b2", Location: "Croydon", Completed: "2024" } },
  6: { description: "A contemporary grey facade renewal combining clean lines and premium materials for lasting kerb appeal and energy efficiency.", specs: { Service: "General Building", Duration: "7 weeks", Area: "140 m\u00b2", Location: "Croydon", Completed: "2023" } },
};

export const getProjectDetail = (id) =>
  PROJECT_DETAILS[id] || {
    description: "A quality build delivered by the EMB team with meticulous craftsmanship and premium materials from start to finish.",
    specs: { Service: "Building & Repair", Duration: "4 weeks", Area: "\u2014", Location: "Croydon", Completed: "2025" },
  };
